import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { axiosGet, axiosPutWithParamBody } from "../../apis/useAxios";
import { RadioGroup, SelectBox } from "devextreme-react";
import { askConfirmation, showResponseMessage } from "../../helpers/message";

const crewTypeCategoryLst = [
  { id: 1, code: "P", name: "Cockpit" },
  { id: 2, code: "F", name: "Cabin Crew" },
  { id: 3, code: "Both", name: "Both" },
];

export default function SetDefaultHotelComponent(props) {
  const [state, setState] = useState({
    isSubmitted: false,
    code: props?.code ?? "",
    hotelCode: "",
    hotelName: "",
    crewTypeCode: crewTypeCategoryLst[2].code,
    fromAirport: props?.fromAirport ?? false,
    rowData: props?.rowData ?? null,
    description: "",
  });
  const [errors, setErrors] = useState({
    hotelValidation: "",
    crewTypeValidation: "",
  });
  const [hotelDropdown, setHotelDropdown] = useState([]);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getHotelDropdown = async (crewTypeCode) => {
    try {
      const response = state.fromAirport
        ? await axiosGet(`HotelTransferContract/hotel-airport-dropdown`, {
            AirportCode: state.code,
            crewTypeCode: crewTypeCode,
          })
        : await axiosGet(`HotelTransferContract/hotel-location-dropdown`, {
            LocationCode: state.code,
            crewTypeCode: crewTypeCode,
          });
      const mergedHotels = Object.values(
        response?.payload?.reduce((acc, curr) => {
          const key = `${curr.name}_${curr.code}`;
          if (!acc[key]) {
            acc[key] = { ...curr, type: [curr.type] };
          } else if (!acc[key].type.includes(curr.type)) {
            acc[key].type.push(curr.type);
          }
          return acc;
        }, {})
      );

      setHotelDropdown(mergedHotels ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const isValidData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.hotelValidation = "";
      err.crewTypeValidation = "";
      if (!state.hotelCode) {
        isValid = false;
        err.hotelValidation = "Please select hotel.";
      }
      if (!state.crewTypeCode) {
        isValid = false;
        err.crewTypeValidation = "Please select crew type.";
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnSetDefaultHotel = async (e) => {
    e.preventDefault();
    try {
      if (isValidData()) {
        let confirmationQuestion = state.fromAirport
          ? `Are You Sure Want To Set Default Hotel - [${state.hotelName}] For Airport Transfer [${state.rowData?.airportName}]?`
          : `Are You Sure Want To Set Default Hotel - [${state.hotelName}] For Ground Duty Transfer [${state.code}]?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSubmitted: true }));
        const response = await axiosPutWithParamBody(
          `HotelTransferContract/set-default-hotel`,
          { AirlineCode: sessionStorage.getItem("session_airlineCode") },
          {
            HotelCode: state.hotelCode,
            Code: state.code,
            CrewTypeCode:
              state.crewTypeCode === crewTypeCategoryLst[2].code
                ? [crewTypeCategoryLst[0].code, crewTypeCategoryLst[1].code]
                : [state.crewTypeCode],
            FromAirport: state.fromAirport,
          }
        );
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isSubmitted: false }));
        if (isConfirmed) {
          if (response?.isSuccess) {
            handleOnCloseSetDefaultHotelModal();
            props.onRefresh();
          }
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSubmitted: false }));
      console.log(error);
    }
  };

  const handleOnCloseSetDefaultHotelModal = () => {
    try {
      props.onClose();
      setState((prev) => ({
        ...prev,
        isSubmitted: false,
        code: "",
        hotelCode: "",
        hotelName: "",
        crewTypeCode: crewTypeCategoryLst[2].code,
        fromAirport: false,
        rowData: null,
        description: "",
      }));
      setHotelDropdown([]);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        onAfterOpen={async () => {
          await getHotelDropdown(state.crewTypeCode);
          let err = { ...errors };
          err.hotelValidation = "";
          err.crewTypeValidation = "";
          setErrors(err);
        }}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {state.fromAirport
              ? `Set Default Hotel For Airport Transfer [${state.rowData?.airportName}]`
              : `Set Default Hotel For Ground Duty Transfer [${state.code}]`}
          </h6>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              handleOnCloseSetDefaultHotelModal();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div className="form-group">
                <label>
                  Hotel&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={hotelDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select Hotel"
                  name="hotelDropdown"
                  defaultValue={state.hotelCode}
                  value={state.hotelCode}
                  displayExpr="name"
                  valueExpr="code"
                  showClearButton={true}
                  searchEnabled={true}
                  disabled={false}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.hotelValidation = "";
                    let crewTypeName = "";
                    if (e.selectedItem?.type?.length > 1) {
                      crewTypeName = "Cockpit and Cabin Crew";
                    } else {
                      crewTypeName =
                        e.selectedItem?.type[0] === "P"
                          ? "Cockpit"
                          : "Cabin Crew";
                    }
                    setState((prev) => ({
                      ...prev,
                      hotelCode: e?.selectedItem?.code ?? "",
                      hotelName: e?.selectedItem?.name ?? "",
                      description: `${e?.selectedItem?.name} is assigned for ${crewTypeName}`,
                    }));
                    setErrors(err);
                  }}
                />
                {errors.hotelValidation.length > 0 && (
                  <span className="error invalid-feedback">
                    {errors.hotelValidation}
                  </span>
                )}
              </div>
            </div>
            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div className="form-group">
                <label>
                  Crew Type&nbsp;<span className="text-danger">*</span>
                </label>
                <RadioGroup
                  id="radio-group-with-selection"
                  dataSource={crewTypeCategoryLst}
                  value={state.crewTypeCode}
                  defaultValue={state.crewTypeCode}
                  valueExpr="code"
                  displayExpr="name"
                  onValueChanged={async (e) => {
                    let err = { ...errors };
                    err.crewTypeValidation = "";
                    setState((prev) => ({
                      ...prev,
                      crewTypeCode: e.value ?? "",
                      hotelCode: "",
                      hotelName: "",
                      description: "",
                    }));
                    setHotelDropdown([]);
                    setErrors(err);
                    if (e.value) {
                      await getHotelDropdown(e.value);
                    } else {
                      await getHotelDropdown(state.crewTypeCode);
                    }
                  }}
                  layout="horizontal"
                />
                {errors.crewTypeValidation.length > 0 && (
                  <span className="error invalid-feedback">
                    {errors.crewTypeValidation}
                  </span>
                )}
              </div>
            </div>
          </div>
          {state.hotelCode && (
            <span style={{ marginLeft: "6px", color: "red" }}>
              Note:- {state.description}
            </span>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Submit"
            className="btn btn-primary"
            onClick={async (e) => {
              await handleOnSetDefaultHotel(e);
            }}
            disabled={state.isSubmitted}
          >
            <i
              className={`fas fa-${
                state.isSubmitted ? "spinner fa-spin" : "check"
              }`}
            />
            &nbsp;&nbsp;Submit
          </button>
          <button
            type="button"
            title="Close"
            className="btn btn-secondary"
            onClick={() => {
              handleOnCloseSetDefaultHotelModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>
    </>
  );
}
